module.exports = __webpack_public_path__ + "static/media/logo-fatenp.eafd1aad.png";